import React from 'react';

// Shared styling standards for the receipt preview (ShowModal), the transaction preview
// (TransactionDetailModal) and the rent payment modal (UpdateTenantRentModal). ShowModal renders
// through the legacy InfoField/HeadingContainer, so the same numbers are repeated in its
// .show-receipt-content rules in neoverv/scss/components/module/receipt/styles.scss — change both.
export const previewSectionHeadingStyle = {
  display: 'block',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '24px',
  color: '#0E0E1D',
  margin: '0 0 16px',
};

export const previewFieldLabelStyle = {
  display: 'block',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
  color: '#4D4D7C',
  margin: '0 0 3px',
};

export const previewFieldValueStyle = {
  display: 'block',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  color: '#0E0E1D',
  margin: 0,
  overflowWrap: 'anywhere',
};

// 60px from the start of one field row to the start of the next:
// 16px label + 3px + 20px value + 21px.
export const PREVIEW_FIELD_ROW_GAP = 21;

// Exact px values go through inline styles: the app sets html { font-size: 14px }, and Mantine
// turns numeric spacing props into rem on a 16px basis, so gap={21} would render as 18.4px.
export function PreviewSectionHeading({ children, style }) {
  return <span style={{ ...previewSectionHeadingStyle, ...style }}>{children}</span>;
}

export function PreviewFieldGrid({ children, cols = 2, columnGap = 24 }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`, columnGap, rowGap: PREVIEW_FIELD_ROW_GAP }}>
      {children}
    </div>
  );
}

// children replaces the plain value, e.g. for a value with an inline action next to it.
export default function PreviewField({ label, value, children }) {
  return (
    <div style={{ minWidth: 0 }}>
      <span style={previewFieldLabelStyle}>{label}</span>
      {children ?? <span style={previewFieldValueStyle}>{value || value === 0 ? value : '-'}</span>}
    </div>
  );
}
